import apiFetch from '../apiFetch'

export default function (filtros, token) {  
  return apiFetch({endPoint: `Analisis/getAnalisisPICTraq`,body:filtros, token, method: 'POST'})
}
